import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserListState, USER_LIST_STATE } from './user-list.state';

export const selectUser = createFeatureSelector<UserListState>(USER_LIST_STATE);

export const selectUserList = createSelector(
  selectUser,
  (state: UserListState) => {
    return state.dataSource;
  }
);

export const selectUserListFilter = createSelector(
  selectUser,
  (state: UserListState) => state.filter
);
